import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import store from "../../../../store";
import LeftWall from "../subparts/walls/leftWall";
import RightWall from "../subparts/walls/rightWall";
import CenterWall from "../subparts/walls/centerWall";
import FrontWall from "../subparts/walls/frontWall";
import Ceiling from "../subparts/walls/ceiling";

export default class Walls extends Part {
  static id = 'Walls';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Walls';
    this.partThumbnail = "";
    this.translateId = "visualizer.kitchen.walls";

    // related items
    this.leftWall = null;
    this.rightWall = null;
    this.centerWall = null;
    this.frontWall = null;
    this.ceiling = null;
    this.backsplash = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Left Wall":
        relatedItemName = "leftWall";
        RelatedItemClass = LeftWall;
        break;
      case "Right Wall":
        relatedItemName = "rightWall";
        RelatedItemClass = RightWall;
        break;
      case "Center Wall":
        relatedItemName = "centerWall";
        RelatedItemClass = CenterWall;
        break;
      case "Front Wall":
        relatedItemName = "frontWall";
        RelatedItemClass = FrontWall;
        break;
      case "Ceiling":
        relatedItemName = "ceiling";
        RelatedItemClass = Ceiling;
        break;
      // case "Shower Shadow":
      //   if (
      //     dbFeature.displayName.includes("Shower Shadow - Divider Wall")
      //     || dbFeature.displayName.includes("Shower Shadow - EX L")
      //     || dbFeature.displayName.includes("Shower Shadow - EX R")
      //     || dbFeature.displayName.includes("Shower Shadow - Popout")
      //     || dbFeature.displayName.includes("Shower Shadow - Pony Wall")
      //   ) {
      //     relatedItemName = "shadows";
      //     RelatedItemClass = Shadow;
      //   }
      //   break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Walls', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts(withHidden = true) {
    return this.relatedItems
      .filter(item => this.filterRelatedItem(item, withHidden))
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  handleSubPartClick() {

  }

  recoverPrevioslySelected(activeRelatedPart) {
    const {activeQuoteIndex} = store.getState().quotesState;
    this.relatedItems.forEach(relatedItem => {
      if (relatedItem.partId !== activeRelatedPart.partId && relatedItem.activeFeatureBeforeAllWalls) {
        if (relatedItem.activeFeatureBeforeAllWalls === "placeholder") {
          relatedItem.placeholderChanged = false;
          relatedItem.firstClick[activeQuoteIndex] = false;
        } else if (!relatedItem.selectedByUser) {
          relatedItem.activeFeatureBeforeAllWalls.clickFromAllWalls();
        }
      }
    });
  }

}
